module.exports = __webpack_public_path__ + "img/preview-icon.4f5cdd58.svg";